import { camelCase } from '../util.js'
const works = []
for (let i = 1; i <= 4; i++) {
  let key = camelCase(`honour-pic-${i}`)
  works.push({
    name: '中国国际广告节 长城奖',
    icon: camelCase('honour-medal'),
    thumb: key,
    zpic: [key]
  })
}

export default works
